import BriefPage from "./pages/BriefPage";

export default [
  { path: "/brief", element: <BriefPage /> }
];
